// extracted by mini-css-extract-plugin
module.exports = {"dotsRightCompleted":"styles_dotsRightCompleted__12OsJ","dotsLeftExit":"styles_dotsLeftExit__2ATAo"};